// @flow
import React from "react"
import _ from "lodash"
import LinearProgress from "material-ui/LinearProgress"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import {List, ListItem} from "material-ui/List"
import * as Util from "../common"
import HiddenIcon from "react-icons/lib/fa/question-circle"
import VisibleIcon from "react-icons/lib/fa/circle"
import CompletedIcon from "react-icons/lib/fa/check-circle"
import PendingIcon from "react-icons/lib/fa/exclamation-triangle"
import {containers} from "@swarm2/core"
import {assertDefined} from "@swarm2/assert"

const M = Util.intlMessages("view.Achievements")
const AM = Util.intlMessages("achievements")

const icon = {
  hidden: <HiddenIcon />,
  visible: <VisibleIcon />,
  complete: <CompletedIcon />,
  pending: <PendingIcon />,
}

function DescText(props) {
  const {achievementName, progress} = props
  // react-intl doesn't allow dots in prop names, boo
  const quotas = _.mapKeys(
    // all non-empty quotas. Booleans are empty, for example.
    _.pickBy(_.mapValues(progress, "quota")),
    // No dots allowed in react-intl value-names.
    (val, key) => key.replace(/\./g, "_"),
  )
  const values = Object.assign(
    {},
    _.mapKeys(quotas, (val, key) => key + "_count"),
    _.mapKeys(
      _.mapValues(quotas, v => <Util.Num val={v} />),
      (val, key) => key + "_text",
    ),
  )
  return (
    <div>
      <AM id={achievementName + ".desc"} values={values} />
    </div>
  )
}
const desc = {
  hidden: props => null,
  visible({achievementName, progress}) {
    return (
      <span style={{color: "inherit"}}>
        <DescText {...{achievementName, progress}} />
        {_.map(
          progress,
          (p, statname) =>
            p.percent == null ? null : (
              <div key={statname}>
                {/*{statname}: */}
                <Util.Num val={p.value} /> / <Util.Num val={p.quota} />
                <LinearProgress mode="determinate" value={p.percent} max={1} />
              </div>
            ),
        )}
      </span>
    )
  },
  complete({achievementName, progress, completedAt}) {
    assertDefined(completedAt, "complete status with no date", completedAt)
    return (
      <span style={{color: "inherit"}}>
        <DescText {...{achievementName, progress}} />
        <div>
          Completed <Util.FromNow since={completedAt} />
        </div>
      </span>
    )
  },
  pending({achievementName, progress}) {
    return (
      <span style={{color: "inherit"}}>
        <DescText {...{achievementName, progress}} />
        <div>
          <i>
            <M id="status.pending" />
          </i>
        </div>
      </span>
    )
  },
}
export function AchievementsItemRender(props: Object) {
  const {achievementName, status, progress, completedAt, error} = props
  switch (error && error.status) {
    case "empty":
      return (
        <span title={error.path}>
          <Util.NotFoundView />
        </span>
      )
    case "pending":
    case "notrequested":
      return (
        <span title={error.path}>
          <Util.LoadingSpinner />
        </span>
      )
    default:
  }
  const entryDesc = assertDefined(desc[status], "invalid status", status)
  const icon_ = assertDefined(icon[status], "invalid status: icon", status)
  return (
    <ListItem
      leftIcon={icon_}
      primaryText={
        status === "hidden" ? <M id="hidden" /> : <AM id={achievementName} />
      }
      secondaryText={entryDesc({
        achievementName,
        status,
        progress,
        completedAt,
      })}
    />
  )
}
export const AchievementsItem = containers.achievements.AchievementsItem(
  AchievementsItemRender,
)

function AchievementsRender(props) {
  const {displayName, achieveNames, charId, error} = props
  switch (error && error.status) {
    case "empty":
      return (
        <span title={error.path}>
          <Util.NotFoundView />
        </span>
      )
    case "pending":
    case "notrequested":
      return (
        <span title={error.path}>
          <Util.LoadingSpinner />
        </span>
      )
    default:
  }
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text={<M id="title" values={{displayName}} />} />
        </ToolbarGroup>
      </Toolbar>
      {achieveNames ? (
        <List>
          {achieveNames.map(name => (
            <AchievementsItem
              key={name}
              charId={charId}
              achievementName={name}
            />
          ))}
        </List>
      ) : (
        <Util.LoadingSpinner />
      )}
      {/*<pre>{JSON.stringify(achievements, null, 2)}</pre>*/}
    </div>
  )
}
export default containers.achievements.Achievements(
  Util.DumpProps(AchievementsRender),
)



// WEBPACK FOOTER //
// ./src/achievements/AchievementsView.js